export default __webpack_public_path__ + "static/media/wasteland.f246fbbf.svg";